import React from 'react';
import './customTimeline.less';

interface TimelineItem {
  text: string;
}

interface CustomTimelineProps {
  items: TimelineItem[];
  className?: string;
}

const CustomTimeline: React.FC<CustomTimelineProps> = ({ items, className }: any): any => {
  return (
    <div className={`custom-timeline ${className}`}>
      {items?.map((item: any, index: any): any => (
        <React.Fragment key={index}>
          {index > 0 && <div className="connector-line" />}
          <div className="timeline-item-box">
            <div className="timeline-item-content">
              <div className="timeline-item-text">
                <div className={`${item?.['completed'] ? 'completed' : item?.['icon']?.props?.children !== undefined ? 'timeline-item-number' : 'completed-icon'} margin-left-9 `}>
                  {item?.['icon']}
                </div>
                <div className="timeline-text">
                  {item?.text?.split('\n')?.map((line: any, indexValue: any): any => (
                    <React.Fragment key={indexValue}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ))}
      <div className="timeline-footer">
        <p className="footer-text">Facing Issues?</p>
        <p>
          For any issues or queries related to your HFR ID, reach out to NHA at
          <a href="mailto:facility@nha.gov.in" className="underlined"> facility@nha.gov.in</a>
        </p>
      </div>
    </div>
  );
};

export default CustomTimeline;
